export default function hasPopupQuery(router) {
  if (!router) return false;
  return router?.history?.current?.query?.popup === 'show';
}
